<template>
	<div>
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="page" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="page-header">
				<div class="page-header-container">
					<div class="page-header-inner">
						<div class="fx">
							<div class="page-header-left">
								<div class="page-header-title">
									<h1>Aurora Elite</h1>
								</div>
								<div class="content custom">
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.aurora.f')}}</div>
									</div>
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.aurora.s')}}</div>
									</div>
								</div>
								<div class="nav-link">
									<div class="buy-wrap bg-0c" @click="onBuy">
										{{ $t('available')}}
									</div>
									<div class="nav-conn">
										<a href="javascript: void (0)" class="link" @click="onTele">
											<span class="iconfont icon-a-telegram"></span>
										</a>
										<a href="javascript: void (0)" class="link pl8" @click="onWhatapp">
											<span class="iconfont icon-whatsapp"></span>
										</a>
									</div>
								</div>
							</div>
							<div class="page-header-right">
								<LazyImage className="viewport" imagePath="/res/img/swiper_4.png"></LazyImage>
							</div>
						</div>
					</div>
				</div>
				<div class="preview-wrap">
					<div class="preview-inner">
						<div class="fx">
							<div class="product-list-wrap">
								<div class="product-item" v-for="(img, index) in imgList" :key="index"
									@click="showPicture(img)">
									<img :src="`/res/img/${img.path}`" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="equipment-parameters" id="equipment-parameters">
			<div class="equipment-parameters-wrap">
				<div class="equipment-parameters-inner">
					<h2>{{ $t('feature.specification') }} </h2>
					<h4>{{ $t('feature.product') }} </h4>
					<div class="equipment-content-main">
						<div class="min-equipment">
							<ul class="equipment-ul-list">
								<li v-for="(title, i) in list" :key="i" :class="curIndex == i ? 'active' : ''">
									<a href="javascript: void (0)" @click="checkData(i)">{{ title.category }}</a>
								</li>
							</ul>
							<div class="equipment-table-wrap">
								<table>
									<tbody v-for="(data, idx) in midData" :key="idx">
										<tr class="key">
											<div>{{ data.name }}</div>
										</tr>
										<tr class="val">
											<div>{{ data.value }}</div>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<p class="equipment-content" v-for="(product, index) in list" :key="index">
						<table>
							<thead>
								<tr>
									<th>{{ product.category }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(s, idx) in product.specs" :key="idx">
									<td class="parameters-name">{{ s.name }}</td>
									<td class="parameters-detail">{{ s.value }}</td>
								</tr>
							</tbody>
						</table>
						</p>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
		<div class="dialog" v-show="isShow">
			<div class="mask"></div>
			<div class="dialog-content">
				<div class="dialog-inner" ref="inner" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<img :src="`/res/img/${path}`" alt="">
				</div>
				<div class="close" @click="closePicture" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<span class="iconfont icon-guanbi"></span>
				</div>
				<div class="banner-swiper">
					<div class="prev" @click="onPrev">
						<span class="iconfont icon-zuojiantou"></span>
					</div>
					<div class="next" @click="onNext">
						<span class="iconfont icon-youjiantou"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'AuroraElite',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				isShow: false,
				path: 'elite/elite1_2.png', // 使用v-show 需指定默认值
				imgList: [{
						path: 'elite/elite1.png',
						dPath: 'elite/elite1_2.png'
					},
					{
						path: 'elite/elite2.png',
						dPath: 'elite/elite2_2.png'
					},
					{
						path: 'elite/elite3.png',
						dPath: 'elite/elite3_2.png'
					},
					{
						path: 'elite/elite4.png',
						dPath: 'elite/elite4_2.png'
					},
					{
						path: 'elite/elite5.png',
						dPath: 'elite/elite5_2.png'
					}
				],
				list: [{
						category: "Packing",
						specs: [{
								name: "Product dimension (WxHxL)",
								value: "W90mm*H18.8mm*L90mm"
							},
							{
								name: "Unit products (G.W.)",
								value: "92.2g"
							},
							{
								name: "Unit packing (G.W.)",
								value: "269.4g"
							},
							{
								name: "Unit packing(WxHxL)",
								value: "W47.3mm*H169mm*L134.7mm"
							}
						]
					},
					{
						category: "Hardware",
						specs: [{
								name: "CPU",
								value: "Quad Core ARM Cortex A53"
							},
							{
								name: "GPU",
								value: "Mali-G31 OPenGL    ES3.2"
							},
							{
								name: "Memory",
								value: "2GB"
							},
							{
								name: "Flash",
								value: "16G"
							},
							{
								name: "WiFi",
								value: "WIFI6 2.4g/5g"
							},
							{
								name: "Bluetooth",
								value: 'It supports Bluetooth remote control and Cannot transfer files'
							}
						]
					},
					{
						category: "Software",
						specs: [{
								name: "O.S.",
								value: "AURORA OS Android 10.0"
							},
							{
								name: "Audio",
								value: "Supports MP3, AAC, WMA, RM, FLAC"
							},
							{
								name: "Image",
								value: "HD JPEG、BMP、GIF、PNG、TIF"
							},
							{
								name: "Language",
								value: "Multi-Language"
							},
							{
								name: "Others",
								value: "Support Email,office suit etc./Support DLNA function /Support 2.4G wireless mouse/keyboard"
							}
						]
					}
				],
				curIndex: 0,
				url: 'https://auroratvos.com/product/tanix-%d0%bc%d0%b5%d0%b4%d0%b8%d0%b0%d0%bf%d0%bb%d0%b5%d0%b5%d1%80-android-2-%d0%b3%d0%b1-16-%d0%b3%d0%b1-wi-fi-%d0%b8%d0%ba-%d0%bf%d0%be%d1%80%d1%82-irda-%d1%87%d0%b5%d1%80%d0%bd%d1%8b%d0%b9/'
			};
		},
		computed: {
			midData() {
				return this.list[this.curIndex].specs || []
			}
		},
		methods: {
			showPicture(img) {
				this.path = img.dPath
				this.isShow = true
				this.$refs.inner.classList.remove('scale-out-center')
			},
			closePicture() {
				this.isShow = false
				this.$refs.inner.classList.add('scale-out-center')
			},
			checkData(idx) {
				this.curIndex = idx
			},
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			onBuy() {
				window.open(this.url)
			},
			onTele () {
				window.open('https://t.me/AuroraMCPlayer')
			},
			onWhatapp () {
				window.open('https://wa.me/79315988108')
			},
			onPrev () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index > 0) {
					this.path = this.imgList[--index].dPath
				}
			},
			onNext () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index < this.imgList.length - 1) {
					this.path = this.imgList[++index].dPath
				}
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>